import axios from "axios";

const isProduction = process.env.NODE_ENV === "production";

const baseURL = isProduction
  ? "https://galpon.gestionterritoriallr.com.ar/"
  : "https://pxh0r724-5000.brs.devtunnels.ms/";
  
const axiosapi = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

axiosapi.interceptors.request.use((config) => {
  if (!isProduction) {
    const token = localStorage.getItem("session");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export default axiosapi;